import React from 'react'
import { getInvoiceStatus, INVOICE_STATUS_META } from '../utils'

export const Badge = ({ className = '', children }) => (
	<span
		className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-[12px] font-medium ${className}`}
	>
		{children}
	</span>
)

// TZ 3: cash -> kulrang «Naqd», credit -> ko'k «Nasiya · {installments}»
export const SaleTypeBadge = ({ saleType, installments }) =>
	saleType === 'credit' ? (
		<Badge className="bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-100">
			Nasiya{installments ? ` · ${installments}` : ''}
		</Badge>
	) : (
		<Badge className="bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-200">
			Naqd
		</Badge>
	)

export const InvoiceStatusBadge = ({ invoice }) => {
	const meta = INVOICE_STATUS_META[getInvoiceStatus(invoice)]
	return <Badge className={meta.className}>{meta.label}</Badge>
}

export const InstallmentStatusBadge = ({ status, overdue }) => {
	if (['Closed', 'closed', 'C'].includes(status))
		return <Badge className="bg-emerald-100 text-emerald-700">Yopiq</Badge>
	if (overdue)
		return <Badge className="bg-rose-100 text-rose-700">Muddati o‘tgan</Badge>
	return <Badge className="bg-slate-100 text-slate-600">Ochiq</Badge>
}
